// Entry point for the build script in your package.json

// Window animation
import WindowAnimation from "./lib/WindowAnimation";
WindowAnimation.start();
document.addEventListener("layoutchanged", function () {
  WindowAnimation.queueLayout();
});

// Collision detection
import CollisionDetector from "./lib/CollisionDetector";
CollisionDetector.start();

// Responsive embeds
import responsiveEmbeds from "./lib/responsiveEmbeds";
responsiveEmbeds();

// Rails
import Rails from "@rails/ujs";
Rails.start();

// Grid overlay
import gridOverlay from "./lib/gridOverlay";
gridOverlay();

// Stimulus
import { Application } from "stimulus";
import CollisionDetectController from "./controllers/CollisionDetectController";
const application = Application.start();
application.register("collision-detect", CollisionDetectController);

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);
